import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthServiceService } from '../../core/http/auth-service.service';
import { BillingService } from '../../core/http/billing.service';
import { SettingsService } from '../../core/http/settings.service';
import { ModalService } from '../../shared/services/modal.service';

@Component({
  selector: 'app-billing',
  templateUrl: './billing.component.html',
  styleUrls: ['./billing.component.scss'],
  animations: [
    trigger('simpleFadeAnimation', [
      // the "in" style determines the "resting" state of the element when it is visible.
      state('in', style({ opacity: 1 })),
      // fade in when created. this could also be written as transition('void => *')
      transition(':enter', [style({ opacity: 0 }), animate(300)]),
      // fade out when destroyed. this could also be written as transition('void => *')
      transition(':leave', animate(300, style({ opacity: 0 }))),
    ]),
  ],
})
export class BillingComponent implements OnInit {
  billItem;
  patient;
  patient_id;
  isVisible = false;
  refVisible = false;
  docIsLoading = false;
  docVisible = false;
  items;
  filteredItems;
  mode = 'form';
  isLoading = true;
  Errors = null;
  authVisible = false;
  data = [];
  price = [];
  opdPrice: any = [];
  total = 0.0;
  discount: number = 0;
  regNo;
  Branch;
  referred_doc;
  Name;
  users: any;
  BarCode;
  success;
  touched = false;
  total_discount: number = 0;
  discount_amout: number = 0;
  No_of_test: number;
  authdoc;
  refdoc;
  billLoad: boolean = false;
  encounterBillItems = [];
  encounterServices = [];
  itemBills = [];
  itemServices = [];
  filteredDocs;
  patientTypeList;
  refCodeList;
  concessionCodeList;
  doctorRef = '';
  canDiscount = [];
  userId = localStorage.getItem('id');
  private _searchText: string;
  private _searchDoc: string;

  get searchText(): string {
    return this._searchText;
  }
  get searchDoc(): string {
    return this._searchDoc;
  }

  set searchText(value: string) {
    this._searchText = value;
    this.filteredItems = this.filterItems(value);
  }
  set searchDoc(value: string) {
    this._searchDoc = value;
    this.filteredDocs = this.filterDocs(value);
  }

  filterItems(searchString: string) {
    return this.items.filter(
      (item) =>
        item.name.toLowerCase().indexOf(searchString.toLowerCase()) !== -1
    );
  }
  filterDocs(searchString: string) {
    return this.referred_doc.filter(
      (item) =>
        item.Acount_Name.toLowerCase().indexOf(searchString.toLowerCase()) !==
        -1
    );
  }

  stateForm = new FormGroup({
    is_final: new FormControl(1),
    id: new FormControl(0),
    patient_type: new FormControl(''),
    registration_no: new FormControl(this.regNo),
    patientName: new FormControl(this.Name),
    branchCode: new FormControl(this.Branch),
    referred_doctor: new FormControl(''),
    ref_hosp_code: new FormControl(''),
    concession_code: new FormControl(''),
    narration: new FormControl(''),
    barcodeno: new FormControl(this.BarCode),
    cardpercent: new FormControl(this.discount),
    billDate: new FormControl(null),
    totalAmount: new FormControl(this.total),
    discount: new FormControl(this.total_discount),
    netAmount: new FormControl(this.discount_amout),
    amountPaid: new FormControl(''),
    amountOutstanding: new FormControl(null),
    discount_narration: new FormControl(''),
    discount_auth_doc_id: new FormControl(null),
    Recd_Payt: new FormControl('No'),
    clinical_history: new FormControl(''),
    encounterBillItems: new FormControl(this.encounterBillItems),
    encounterServices: new FormControl(this.encounterServices),
  });

  get formControls(): any {
    return this.stateForm['controls'];
  }

  constructor(
    public router: Router,
    private modal: ModalService,
    private _snackBar: MatSnackBar,
    public setting: SettingsService,
    public auth: AuthServiceService,
    public bill: BillingService,
    routeActivate: ActivatedRoute
  ) {
    routeActivate.params.subscribe((val) => {
      this.billItem = this.auth._billItem;
      console.log(this.billItem, 'BillItemmmmmmmm');
      this.patient = this.auth._patient;
      this.discount = this.patient?.card_per || this.billItem?.cardpercent;
      this.BarCode = this.patient?.Barcode_No || this.billItem?.barcode_no;
      this.Branch = this.patient?.Branch_Code || this.billItem?.branchCode;
      this.regNo =
        this.patient?.registration_no || this.billItem?.registration_no;
      this.Name = this.patient?.first_name || this.billItem?.firstName;
      this.doctorRef = this.billItem?.referred_doctor;
      this.patient_id =
        this.patient?.registration_no || this.billItem?.registration_no;
      console.log(this.patient);
      // this.stateForm.patchValue({
      //   ref_hosp_code:
      //     this.patient?.ref_doct_code || this.billItem?.referred_doctor,
      //   referred_doctor: this.billItem?.referred_doctor,
      // });

      // FOR BILL UPDATE

      if (this.billItem) {
        this.stateForm.patchValue(this.billItem);

        if (this.billItem.encounterBillItems) {
          this.encounterBillItems = [...this.billItem.encounterBillItems];
        }
        if (this.billItem.encounterServices) {
          this.encounterServices = [...this.billItem.encounterServices];
        }
        this.discount_amout = this.billItem?.netAmount;
        this.total_discount = this.billItem?.discount;
        this.total = this.billItem?.totalAmount;
        this.opdPrice = [...this.billItem.encounterServices];

        if (this.encounterBillItems && this.encounterServices) {
          // Assuming that encounterBillItems and encounterServices
          // are formatted similarly to data and opdPrice respectively
          this.data = this.encounterBillItems.map((item) => ({
            name: item.service_name,
            service_price: item.net_amount,
            dept_code: item.dept_code,
            sub_dept_code: item.sub_dept_code,
            service_code: item.service_code,
            dept_name: item.dept_name,
            sub_dept_name: item.sub_dept_name,

            //       is_opd: item.is_opd || false,
            // service_code: item?.id || item?.service_code,
            // service_name: item?.name || item?.service_name,
            // discounted_amount: '',
            // discount: this.total_discount,
            // net_amount: item?.service_price || this.discount_amout,
            // no_of_test: 1,
            // dept_code: item.dept_id || item?.dept_code,
            // sub_dept_code: item.sub_dept_id || item?.sub_dept_code,
          }));

          // Call addItems to ensure all data is correctly formatted and up-to-date
          this.addItems();
          // console.log(this.data, 'Dataaaaaaaaaaaaaaaaa');
        }
      }

      this.setting.getUser().subscribe(
        (resSuccess: any) => {
          this.users = resSuccess.filter((t) => t.CanAuthDiscount == true);
          // console.log(this.users, 'Userrrrrrrrrrrrrrrrrrrrrrrrrr');
          this.canDiscount = this.users.filter(
            (t) => t.Employee_id === +this.userId
          );
          console.log(this.canDiscount, 'Dissssssssssssssss');
        },
        (resErr) => {
          this.isLoading = false;
          this.Errors = resErr;
        }
      );

      this.setting.getPatientType().subscribe(
        (resSuccess: any) => {
          this.patientTypeList = resSuccess;
          // console.log(this.patientTypeList, 'Patient Typeee');
        },
        (resErr) => {
          this.isLoading = false;
          this.Errors = resErr;
        }
      );

      this.setting.getRefHospCode().subscribe(
        (resSuccess: any) => {
          this.refCodeList = resSuccess;
          console.log(this.refCodeList, 'refCodeListt');
        },
        (resErr) => {
          this.isLoading = false;
          this.Errors = resErr;
        }
      );

      this.setting.getConcessionCode().subscribe(
        (resSuccess: any) => {
          this.concessionCodeList = resSuccess;
          console.log(this.concessionCodeList, 'concessionCodeListtt');
        },
        (resErr) => {
          this.isLoading = false;
          this.Errors = resErr;
        }
      );

      // this.setting.getBillItems(this.patient_id, this.patient?.sponsor_code ?? 0).subscribe(
      this.setting.getBillItems(this.patient_id, 0).subscribe(
        (resSuccess: any) => {
          this.items = resSuccess.map((item) => ({
            selected: false,
            Daily: item.Daily,
            Methodology: item.Methodology,
            NABL_Accredited: item.NABL_Accredited,
            dept_id: item.dept_id,
            dept_name: item.dept_name,
            direct_revenue: item.direct_revenue,
            doctor_reqd: item.doctor_reqd,
            id: item.id,
            is_opd: item.is_opd,
            name: item.name,
            one_time: item.one_time,
            price_editable: item.price_editable,
            profile: item.profile,
            release_dr_fee_when_unsettled: item.release_dr_fee_when_unsettled,
            report_type: item.report_type,
            service_price: item.service_price,
            soc_id: item.soc_id,
            status: item.status,
            sub_dept_id: item.sub_dept_id,
            sub_dept_name: item.sub_dept_name,
          }));
          this.filteredItems = this.items;

          this.isLoading = false;
          console.log(this.filteredItems);
        },
        (resErr) => {
          this.isLoading = false;
          this.Errors = resErr;
        }
      );

      this.setting.getRefDr().subscribe(
        (resSuccess) => {
          this.referred_doc = resSuccess;
          console.log(this.referred_doc, 'Doctorrrrrrrrr');
          this.filteredDocs = this.referred_doc;
          this.docIsLoading = false;
        },
        (resErr) => {
          this.docIsLoading = false;
          this.Errors = resErr;
        }
      );
      console.log(this.doctorRef, 'mountttttttttttt');
    });
  }
  ngOnInit(): void {}
  percentage(percent, total) {
    return (percent / 100) * total;
  }
  reverse(percent, total) {
    return (100 / total) * percent;
  }
  formatData() {
    let totalChild = this.data.reduce(
      (accum, item) => accum + item.service_price,
      0
    );
    this.total = totalChild;
    this.total_discount = this.percentage(this.discount, totalChild);
    this.discount_amout = this.total - this.total_discount;
  }

  addItems() {
    this.encounterBillItems = this.data.map((item) => ({
      is_opd: item.is_opd || false,
      service_code: item?.id || item?.service_code,
      service_name: item?.name || item?.service_name,
      discounted_amount: '',
      discount: this.total_discount || 0,
      net_amount: item?.service_price || this.discount_amout,
      no_of_test: 1,
      dept_code: item.dept_id || item?.dept_code,
      sub_dept_code: item.sub_dept_id || item?.sub_dept_code,
    }));

    this.encounterServices = this.opdPrice.map((item) => ({
      service_code: item?.id || item?.service_code,
      service_name: item?.name || item?.service_name,
      service_amount: item?.service_price || item?.net_amount,
      no_of_test: 1 || item?.no_of_test,
      dept_code: item?.dept_id || item?.dept_code,
      sub_dept_code: item?.sub_dept_id || item?.sub_dept_code,
    }));
    this.total_discount = 0;
    this.discount = 0;
    console.log(this.total_discount, 'Discounttttttt');
    console.log(this.encounterBillItems, 324);
    console.log(this.encounterServices, 325);
  }

  addItem(item) {
    let index = this.filteredItems.indexOf(item);
    item.selected = true;
    this.filteredItems[index] = item;
    console.log(this.data, 'beforeeeeeeeee');
    console.log(this.opdPrice, 'beforeeeeeeeee2222222222');

    if (!this.data.find((i) => i.id === item.id)) {
      this.data.push(item);
    }
    if (item.is_opd) {
      // this.setting.getItemOPD(item.id).subscribe(
      //   (resSuccess) => {
      //     console.log(resSuccess);
      //     this.opdPrice.push(item);
      //     this.formatData();
      //     this.addItems();
      //     console.log(this.stateForm.value);
      //   },
      //   (resErr) => {
      //     this.isLoading = false;
      //     this.Errors = resErr;
      //     console.log(this.stateForm.value);
      //   }
      // );
      if (!this.opdPrice.find((i) => i.id === item.id)) {
        this.opdPrice.push(item);
      }
      this.formatData();
      this.addItems();
      console.log(this.stateForm.value);
    } else {
      if (!this.opdPrice.find((i) => i.id === item.id)) {
        this.opdPrice.push(item);
      }
      this.formatData();
      this.addItems();
      console.log(this.stateForm.value);
    }
    console.log(this.data, 'Dataaaaaaaaaaaaaaaaa');
    console.log(this.opdPrice, 'Opddddddddddddddd');
    this.formatData();
  }
  deleteItem(item) {
    console.log(item);
    let index = this.filteredItems.indexOf(item);
    console.log(index);
    item.selected = false;
    this.filteredItems[index] = item;
    this.opdPrice = this.opdPrice.filter(
      (t) => t.name !== item?.name || item?.service_name
    );
    this.data = this.data.filter((t) => t.name !== item?.name);
    this.formatData();
    this.addItems();
  }

  switch() {
    this.mode = 'discount';
  }
  setRef(item) {
    this.refdoc = item.Acount_Name;
    this.stateForm.patchValue({
      referred_doctor: item.Acount_Name,
      // ref_hosp_code: item.ref_doctor_code,
    });
    this.docVisible = false;
    this._searchDoc = '';
  }
  setAuth(item) {
    this.authdoc = item.Acount_Name;
    this.stateForm.patchValue({
      discount_auth_doc_id: item.ref_doctor_code,
    });
    this.authVisible = false;
    this._searchDoc = '';
  }
  addRefDoc(item) {
    console.log(item.Acount_Name);
    this.stateForm.patchValue({
      referred_doctor: item.Acount_Name,
    });
    this.refVisible = !this.refVisible;
    this.doctorRef = item.Acount_Name;
  }
  addDoc() {
    this.docVisible = !this.docVisible;
    this.docIsLoading = true;
    this.setting.getRefDr().subscribe(
      (resSuccess) => {
        this.referred_doc = resSuccess;
        this.docIsLoading = false;
      },
      (resErr) => {
        this.docIsLoading = false;
        this.Errors = resErr;
      }
    );
  }
  addAuth() {
    this.authVisible = !this.authVisible;
    this.docIsLoading = true;
    this.setting.getRefDr().subscribe(
      (resSuccess) => {
        this.referred_doc = resSuccess;
        this.docIsLoading = false;
      },
      (resErr) => {
        this.docIsLoading = false;
        this.Errors = resErr;
      }
    );
  }
  back() {
    this.mode = 'form';
  }

  togle() {
    this.isVisible = !this.isVisible;
  }
  refVisibility() {
    this.refVisible = !this.refVisible;
  }
  onChange() {
    this.formatData();
  }
  clear() {
    this.data = [];
    this.opdPrice = [];
    this.total = 0;
    this.discount_amout = 0;
    this.total_discount = 0;
  }
  onChangePer() {
    let totalChild = this.data.reduce(
      (accum, item) => accum + item.service_price,
      0
    );
    this.total = totalChild;
    this.discount = this.reverse(this.total_discount, totalChild);
    this.discount_amout = this.total - this.total_discount;
    this.touched = true;
  }
  updateForm() {
    this.stateForm.patchValue({
      encounterBillItems: this.encounterBillItems,
      encounterServices: this.encounterServices,
      registration_no: this.regNo,
      patientName: this.Name,
      branchCode: this.Branch,
      barcodeno: this.BarCode,
      cardpercent: this.discount,
      totalAmount: this.total,
      discount: this.total_discount,
      netAmount: this.discount_amout,
    });

    console.log(this.encounterBillItems);
  }

  saveDraft() {
    this.stateForm.patchValue({
      is_final: 0,
    });
  }

  onSubmit(e) {
    e.preventDefault();
    if (this.doctorRef === '') {
      this._snackBar.open('Select a ref doctor', '', {
        duration: 7000,
        verticalPosition: 'top',
      });
    } else if (this.total_discount || this.discount) {
      if (!this.stateForm.value.discount_auth_doc_id) {
        this._snackBar.open(
          'Please select Dr that authorized Discount and reason',
          '',
          {
            duration: 7000,
            verticalPosition: 'top',
          }
        );
      } else if (!this.stateForm.value.discount_narration) {
        this._snackBar.open(
          'Please select Dr that authorized Discount and reason',
          '',
          {
            duration: 7000,
            verticalPosition: 'top',
          }
        );
      } else {
        this.billLoad = true;
        this.updateForm();
        this.isLoading = true;
        this.Errors = null;
        const {
          is_final,
          id,
          patient_type,
          registration_no,
          patientName,
          branchCode,
          referred_doctor,
          ref_hosp_code,
          concession_code,
          narration,
          barcodeno,
          cardpercent,
          billDate,
          totalAmount,
          discount,
          netAmount,
          amountPaid,
          amountOutstanding,
          discount_narration,
          discount_auth_doc_id,
          Recd_Payt,
          clinical_history,
          encounterServices,
          encounterBillItems,
        } = this.stateForm.value;
        console.log(this.stateForm.value);
        this.bill
          .postBill(
            is_final,
            id,
            patient_type,
            registration_no,
            patientName,
            branchCode,
            referred_doctor,
            ref_hosp_code,
            concession_code,
            narration,
            barcodeno,
            cardpercent,
            billDate,
            totalAmount,
            discount,
            netAmount,
            amountPaid,
            amountOutstanding,
            discount_narration,
            discount_auth_doc_id,
            Recd_Payt,
            clinical_history,
            encounterServices,
            encounterBillItems
          )
          .subscribe(
            (resSuccess) => {
              this.billLoad = false;
              this.success = resSuccess;
              this.isLoading = false;
              console.log(resSuccess);

              if (this.success.success) {
                // this.closeModal()
                this._snackBar.open('Saved Successfully', '', {
                  duration: 2000,
                  verticalPosition: 'top',
                });
                this.billLoad = false;
                this.router.navigateByUrl('/print-invoice');
                this.clear();
              } else {
                this.Errors = 'Not successful, please try again';
                this._snackBar.open('Not successful, please try again', '', {
                  duration: 4000,
                  verticalPosition: 'top',
                });
                console.log(resSuccess);
              }
            },
            (resErr) => {
              this.isLoading = false;
              this.Errors = resErr;
              console.log(resErr);
            }
          );
      }
    } else {
      this.billLoad = true;
      this.updateForm();
      this.isLoading = true;
      this.Errors = null;
      const {
        is_final,
        id,
        patient_type,
        registration_no,
        patientName,
        branchCode,
        referred_doctor,
        ref_hosp_code,
        concession_code,
        narration,
        barcodeno,
        cardpercent,
        billDate,
        totalAmount,
        discount,
        netAmount,
        amountPaid,
        amountOutstanding,
        discount_narration,
        discount_auth_doc_id,
        Recd_Payt,
        clinical_history,
        encounterServices,
        encounterBillItems,
      } = this.stateForm.value;
      console.log(this.stateForm.value);
      this.bill
        .postBill(
          is_final,
          id,
          patient_type,
          registration_no,
          patientName,
          branchCode,
          referred_doctor,
          ref_hosp_code,
          concession_code,
          narration,
          barcodeno,
          cardpercent,
          billDate,
          totalAmount,
          discount,
          netAmount,
          amountPaid,
          amountOutstanding,
          discount_narration,
          discount_auth_doc_id,
          Recd_Payt,
          clinical_history,
          encounterServices,
          encounterBillItems
        )
        .subscribe(
          (resSuccess) => {
            this.billLoad = false;
            this.success = resSuccess;
            this.isLoading = false;
            console.log(resSuccess);

            if (this.success.success) {
              // this.closeModal()
              this._snackBar.open('Saved Successfully', '', {
                duration: 2000,
                verticalPosition: 'top',
              });
              this.billLoad = false;
              this.router.navigateByUrl('/print-invoice');
            } else {
              this.Errors = this.success.message;
              this._snackBar.open(this.success.message, '', {
                duration: 4000,
                verticalPosition: 'top',
              });
            }
          },
          (resErr) => {
            this.isLoading = false;
            this.Errors = resErr;
            console.log(resErr);
          }
        );
    }
  }
}
